var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserMobileNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11797_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5C15.2625 12.5 17.5 10.2625 17.5 7.5C17.5 4.7375 15.2625 2.5 12.5 2.5C9.7375 2.5 7.5 4.7375 7.5 7.5C7.5 10.2625 9.7375 12.5 12.5 12.5ZM12.5 15C9.1625 15 2.5 16.675 2.5 20V22.5H22.5V20C22.5 16.675 15.8375 15 12.5 15Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11797_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMobileNav);
export default __webpack_public_path__ + "static/media/user_mobile_nav.1b734a9e1d458a507c425a2c2aa5bb58.svg";
export { ForwardRef as ReactComponent };